module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n    <meta charset=\"utf-8\" />\r\n    <title></title>\r\n</head>\r\n<body>\r\n    <a class=\"btn btn-primary BrowseFile\">\r\n        <input #fileInput type=\"file\" />\r\n        Browse\r\n    </a>\r\n    <button (click)=\"AddFile()\" class=\"btn btn-primary\">Upload</button>\r\n\r\n    <div class=\"AssessmentTimer\">\r\n        <span id=\"demo\"></span>\r\n    </div>\r\n</body>\r\n</html>"


//////////////////
// WEBPACK FOOTER
// ./src/app/SharedComponents/FileUploader.html
// module id = ./src/app/SharedComponents/FileUploader.html
// module chunks = main